import { render, staticRenderFns } from "./Workshop-Club.vue?vue&type=template&id=2e0ac102&scoped=true"
import script from "./Workshop-Club.vue?vue&type=script&lang=js"
export * from "./Workshop-Club.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ac102",
  null
  
)

export default component.exports